import { render } from "./AgentTableNameCellCompactView.vue?vue&type=template&id=7feaf136&scoped=true&ts=true"
import script from "./AgentTableNameCellCompactView.vue?vue&type=script&lang=ts"
export * from "./AgentTableNameCellCompactView.vue?vue&type=script&lang=ts"

import "./AgentTableNameCellCompactView.vue?vue&type=style&index=0&id=7feaf136&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7feaf136"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QChip});
